var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_c('el-carousel',{attrs:{"trigger":"click","height":"350px"}},_vm._l((_vm.scrImg),function(item){return _c('el-carousel-item',{key:item},[_c('img',{staticStyle:{"width":"100%","height":"350px"},attrs:{"src":item,"alt":""}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }